import { ILabelControl } from '@infotech-soe/metaschema';

import { TActionArgsValues } from '../../../../infrastructure/providers/abstract/IApiProvider';
import {
  FormControlViewModelType,
  LabelFormControlViewModel,
  LocalizedProps,
} from '../../view-model/FormControlViewModel';

const buildLabelControl = async (
  item: ILabelControl,
  localizedProps: LocalizedProps,
  args: TActionArgsValues
): Promise<LabelFormControlViewModel> => ({
  columns: item.columns,
  noLabel: item.noLabel,
  type: FormControlViewModelType.LABEL,
  name: item.name,
  value: args[item.name] || '',
  hasValue: true,
  hasHistory: false,
  visible: item.visible,
  ...localizedProps,
});

export default buildLabelControl;
